import { useApiFetcherSWR } from "hooks/SwrCustom";


export const API_ENDPOINT = {
  GET_REQUEST_DETAILS: {
    url: "requests",
    method: "get",
  },

  UPDATE_REQUISITION: {
    url: "requisition",
    method: "patch",
  },
};

export const useRequestDetails = (substitutionId, swrOptions = {}) =>
  useApiFetcherSWR(
    substitutionId
      ? {
          ...API_ENDPOINT.GET_REQUEST_DETAILS,
          url: `${API_ENDPOINT.GET_REQUEST_DETAILS.url}/${substitutionId}`,
        }
      : null,
    swrOptions
  );

export const useUpdateRequisition = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_REQUISITION);